/* AUTH */
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_BY_GOOGLE = 'LOGIN_USER_BY_GOOGLE';
export const LOGIN_USER_BY_FACEBOOK = 'LOGIN_USER_BY_FACEBOOK';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_SUCCESS_TOKEN = 'LOGIN_USER_SUCCESS_TOKEN';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAILED = 'REGISTER_USER_FAILED';
export const LOGOUT_USER = 'LOGOUT_USER';
export const FORGET_PASSWORD = 'FORGET_PASSWORD';
export const FORGET_PASSWORD_SUCCESS = 'FORGET_PASSWORD_SUCCESS';
export const FORGET_PASSWORD_FAILED = 'FORGET_PASSWORD_FAILED';
export const GET_OTP = 'GET_OTP';
export const SET_TOKEN = 'SET_TOKEN';
export const GET_USER_DETAIL = 'GET_USER'
export const LOGIN_USER_BY_FIREBASE = 'LOGIN_USER_BY_FIREBASE'
export const LOGIN_USER_SENDED_OTP = 'LOGIN_USER_SENDED_OTP'
export const SET_PENDING = 'SET_PENDING'
export const REHYDRATE = 'REHYDRATE'
export const LOGOUT_AND_REGISTER_USER = 'LOGOUT_AND_REGISTER_USER'
export const UPDATE_BRANCH = 'UPDATE_BRANCH'
export const GET_USER_LIST = 'GET_USER_LIST'




